/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LockOutline from './lock-outline-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LockOutline {...validProps} />;
}
SvgComponent.iconName = 'lockOutline';

export const LockOutlineIcon = svgIconWrapper(SvgComponent);
